import React from "react";
import Connector from "../../../redux/connector";
import PageBuilder from "../../../components/web/Common/PageBuilder";

class AgendaCategoryPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        let StateStorage = [
            {stateField: "Data", moduleEntity: "lead/entity", table: "batchs", noCondition: false},
            {stateField: "Companies", moduleEntity: "client/entity", table: "company", noCondition: false},
        ];
        let displayListColumns = [
            {id: "Client", label: "Company"},
            {id: "Name", label: "Name"},
        ]
        let translateFields = [
            {
                keyName: "Client",
                keySearch: "CustomerNumber",
                keyValue: "Org",
                keyReturn: "Name",
                stateEntity: "Companies"
            }
        ];
        let entityOptions = [
        ];
        let bldOptions = [
            {
                label: "Name of Company",
                message: "Please select your company name",
                key: "CustomerNumber",
                value: "Name",
                lookInState: true,
                targetStorage: "Companies",
                StateKey: "Org"
            },
        ];
        let bldFields = [
            {
                label: "Name",
                message: "Please input your batch name",
                type: "text",
                StateKey: "Name",
                required:true
            },
            /*{
                label: "Description",
                message: "Please input your description",
                type: "text",
                StateKey: "Description",
                required:true
            },*/
        ]
        return (
            <PageBuilder
                pageTitle={"Agenda"}
                StateStorage={StateStorage}
                displayListColumns={displayListColumns}
                displayTableKeyState={"Data"}
                hasTranslateField={true}
                translateFields={translateFields}
                entityOptions={entityOptions}
                bldOptions={bldOptions}
                bldFields={bldFields}
                newFormTitle={"New Agenda"}
                postMsgResponse={"Thank you, Category agenda submitted!"}
                postMsgWarning={"Are you sure you want to submit this agenda category"}
                postEndpoint={"/agenda/entity/insert/category"}
            />
        )
    }

}

export default Connector(AgendaCategoryPage);

const styles = {
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
}
